export const SOURCERY_ACADEMY =
  'https://devbridge.us4.list-manage.com/subscribe/post?u=64cee96428c9a84d3986c5864&amp;id=4a177b79d9';
